import React from "react";
import {PopupItem} from "../caos-def";


export type PopupElementProps = {
    index: number;
    popupElement: PopupItem;
    popPopupElement: (kind: PopupItem) => void;
    children: React.JSX.Element;
}


export default function PopupElement(
    props: PopupElementProps,
) {

    const {
        popupElement,
        popPopupElement
    } = props;

    const zIndex = 8888 + props.index

    function closeDialog(e: React.MouseEvent) {
        const dialog = ((e.target as HTMLElement).closest("dialog") as HTMLDialogElement);
        dialog.close();
        popPopupElement(popupElement);
    }

    return <dialog open style={ {zIndex: zIndex} }>
        <button className="close-button" onClick={closeDialog}>
            <img src="./icons/close.png" alt="close" />
        </button>
        <div className="content">
            { React.Children.only(props.children) }
        </div>
    </dialog>
}